import { Location } from "@/reducers/locationsSlice"

export const CAR_SPEED_FLAG = "car-speed-ui"

// A provider that stops publishing leaves its last speed behind; past this
// age the number says more about the GPS than about the car.
const MAX_AGE_MS = 15 * 60 * 1000

/** "62 km/h", or undefined when there is no speed or it is too old to trust. */
export const carSpeedLabel = (
  location: Location | undefined,
  now: number = Date.now(),
): string | undefined => {
  if (location?.speed === undefined || !location.timestamp) return undefined
  const takenAt = Date.parse(location.timestamp)
  if (!(now - takenAt <= MAX_AGE_MS)) return undefined
  return `${Math.round(location.speed)} km/h`
}
